export default __webpack_public_path__ + "static/media/003-engineering.f5ee5e22.png";